export const clipboardEventName = 'onClipboardChanged';

export { default } from './web/ClipboardModule';
